// extracted by mini-css-extract-plugin
export var container = "_55-0";
export var fallback = "_55-5";
export var fallbackIcon = "_55-6";
export var hidden = "_55-2";
export var image = "_55-3";
export var loaded = "_55-4";
export var placeholder = "_55-1";